'use client';

import type { SymbolCodepoints } from '@umodeapporg/ui/components/UI/MaterialSymbol';
import { MaterialSymbol } from '@umodeapporg/ui/components/UI/MaterialSymbol';
import { useTranslation } from 'react-i18next';

type Highlight = {
  icon: SymbolCodepoints;
  title: string;
  description: string;
};

export default function Home() {
  const { t } = useTranslation('common');

  const highlights: Array<Highlight> = [
    { icon: 'layers', title: t('home.steps.webTitle'), description: t('home.steps.webDescription') },
    { icon: 'dns', title: t('home.steps.apiTitle'), description: t('home.steps.apiDescription') },
    { icon: 'database', title: t('home.steps.dataTitle'), description: t('home.steps.dataDescription') },
  ];

  return (
    <div className="p-6">
      <div className="animate-fade-in-up mx-auto max-w-4xl py-10">
        <div className="text-center">
          <h1 className="text-3xl font-semibold tracking-tight">{t('home.placeholder')}</h1>
          <p className="text-foreground-subtle mx-auto mt-3 max-w-2xl text-sm leading-relaxed">{t('home.subtitle')}</p>
        </div>

        <div className="tablet:grid-cols-3 mt-10 grid grid-cols-1 gap-4">
          {highlights.map((highlight) => (
            <article
              key={highlight.title}
              className="border-border bg-surface interactive hover:border-brand-border rounded-lg border p-5 shadow-xs hover:shadow-md"
            >
              <span className="bg-brand-soft text-brand-emphasis flex size-9 items-center justify-center rounded-md">
                <MaterialSymbol icon={highlight.icon} size={18} />
              </span>
              <h2 className="mt-4 text-sm font-semibold">{highlight.title}</h2>
              <p className="text-foreground-subtle mt-1.5 text-sm leading-relaxed">{highlight.description}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
